import { Version } from '@angular/core';

export const VERSION = new Version('1.4.0');
